import React from 'react';

const PersonCard = ({ image, name, role }) => {
  return (
    <div className="person-card">
      <img src={image} className="person-card-img" alt={name} />
      <div className="card-body">
        <h3 className="card-title">{name}</h3>
        <p className="card-text"><em>{role}</em></p>
      </div>
    </div>
  );
};

export default PersonCard;